export const headers = {
    initialHeaders:[
        {title: 'Fecha de creación', field: 'creation', child: null},
        {title: 'Laboratorio', field: 'laboratory', child: null},
        {title: 'Empresa', field: 'company', child: null},
    ]
}